module.exports = __webpack_public_path__ + "img/scan-qr-hand.f4ca5698.svg";